<div class="form-modal" *ngIf="form">
  <h1 mat-dialog-title>{{listName}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="form" class="form-horizontal modal-dialog-custom">
      <div class="row">

        <div class="col-sm-12" *ngIf="formAllErrors.length > 0">
          <div class="alert alert-danger">
            <ul [innerHtml]="formAllErrors | safeHtml"></ul>
          </div>
        </div>

        <!-- Lista de Códigos -->
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div class="panel-body no-horizontal-padding">

              <div class="form-group" *ngFor="let item of form.controls; let i=index" [formGroupName]="i">
                <div class="col-sm-12">
                  <mat-form-field class="full-width">
                    <input type="text" matInput placeholder="{{'N'|translate}}" formControlName="Code">

                    <button type="button" matSuffix class="no-btn" *ngIf="form.enabled && i > 0">
                      <i class="far fa-trash-alt color-danger" (click)="deleteRow(i)"></i>
                    </button>
                  </mat-form-field>
                  <mat-error *ngIf="formErrors[i].Code" class="font75per">
                    {{formErrors[i].Code}}</mat-error>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <button type="button" class="btn btn-sm btn-primary no-margin" title="{{'BUTTON.NEW' | translate}}"
                    (click)="addRow()" *ngIf="form.enabled">
                    <i class="fas fa-plus"></i>&nbsp;{{'BUTTON.NEW' | translate}}
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <!-- Edição -->
    <div class="full-width text-right" *ngIf="form.enabled">
      <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}"
        (click)="dialogRef.close(false)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
      </button>
      <button type="button" class="btn btn-primary" title="{{'BUTTON.SAVE' | translate}}" (click)="save()">
        <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
      </button>
    </div>

    <!-- Consulta -->
    <div class="full-width text-right" *ngIf="form.disabled">
      <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(false)">
        {{'CLOSE' | translate}}
      </button>
    </div>
  </div>
</div>